export default {
  userList: [],
  editedUser: {},
  loginUser: [],
  isLoading: true,
};
